import { UserResponsesManagerState, userResponsesManagerInitialState } from './State'

import {
  SET_USER_RESPONSES,
  SET_IS_UPDATING_RESPONSE,
  SET_IS_LOADING_RESPONSES,
  SET_RESPONSE_LOCALLY,
  SET_VALIDATION_AND_TOTALS,
  RESET,
  UserResponsesManagerAction
} from './Actions'

function userResponsesManagerReducer(
  state: UserResponsesManagerState,
  action: UserResponsesManagerAction
): UserResponsesManagerState {
  switch (action.type) {
    case SET_USER_RESPONSES:
      return Object.assign({}, state, { userResponses: { ...state.userResponses, ...action.payload } })
    case SET_IS_LOADING_RESPONSES:
      return Object.assign({}, state, { isLoadingResponses: action.payload })
    case SET_IS_UPDATING_RESPONSE:
      return Object.assign({}, state, { isUpdatingResponse: action.payload })
    case SET_RESPONSE_LOCALLY:
      return {
        ...state,
        userResponses: {
          ...state.userResponses,
          responses: {
            ...state.userResponses.responses,
            ...action.payload
          }
        }
      }
    case SET_VALIDATION_AND_TOTALS:
      return {
        ...state,
        userResponses: {
          ...state.userResponses,
          validation: action.payload.validation
        }
      }
    case RESET:
      return userResponsesManagerInitialState
    default:
      return state
  }
}

export default userResponsesManagerReducer
